import React, { FC } from 'react';
import { View, Text, StyleSheet } from 'react-native';

import { isPhone } from '@helpers';
import { scale } from '@components/frame';
import ColorWrapper from '@styles/colors';
import { font } from '@styles/fonts';
import { ColorFunction } from '@styles/colors/types';

interface StatusBlockProps {
  status: any;
  C: ColorFunction;
  dummy?: boolean;
}

const StatusBlock: FC<StatusBlockProps> = ({ status, C, dummy }) => {
  return (
    <View
      style={[
        {
          backgroundColor: C('Gray / Light / 6'),
          borderTopColor: C('Hairline / Light / No trans'),
          borderBottomColor: C('Hairline / Light / No trans'),
          flexDirection: 'row',
          justifyContent: 'center',
          justifyContent: 'space-around',
          height: scale(isPhone ? 29 : 28),
          borderTopWidth: StyleSheet.hairlineWidth,
          borderBottomWidth: StyleSheet.hairlineWidth,
          opacity: dummy ? 0 : 1,
        },
      ]}
    >
      {status.map((item: any) => (
        <View style={{ flexDirection: 'row', alignItems: 'center' }} key={item.name}>
          <View style={[{ backgroundColor: item.color, width: scale(8), height: scale(8), borderRadius: scale(4), marginRight: scale(4) }]} />
          <Text style={[{ color: C('Label/Light/Secondary') }, font['Subhead 1']]}>{item.count}</Text>
          <Text
            style={[
              {
                color: C('Label / Light / Secondary'),
                marginLeft: scale(4),
              },
              font.Small,
            ]}
          >
            {item.name}
          </Text>
        </View>
      ))}
    </View>
  );
};

export default ColorWrapper(StatusBlock);
